(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    var titleVariantDrawerEls = null;
  var titleVariantDrawerProduct = null;
  var titleVariantDrawerSelections = [];

  function ensureTitleVariantDrawer() {
    if (titleVariantDrawerEls) return titleVariantDrawerEls;

    var overlay = document.createElement('div');
    overlay.className = 'title-variant-drawer-overlay';

    var drawer = document.createElement('div');
    drawer.className = 'title-variant-drawer';
    drawer.innerHTML =
      '<div class="title-variant-drawer__header">' +
        '<h3 class="title-variant-drawer__heading">Make a selection</h3>' +
        '<button type="button" class="title-variant-drawer__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="title-variant-drawer__body">' +
        '<div class="title-variant-drawer__product">' +
          '<h4 class="title-variant-drawer__product-title"></h4>' +
          '<div class="title-variant-drawer__product-price"></div>' +
        '</div>' +
        '<div class="title-variant-drawer__options"></div>' +
        '<div class="title-variant-drawer__error" style="display:none;"></div>' +
      '</div>' +
      '<div class="title-variant-drawer__footer">' +
        '<button type="button" class="title-variant-drawer__submit" disabled>ADD TO CART</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    var closeBtn = drawer.querySelector('.title-variant-drawer__close');
    var submitBtn = drawer.querySelector('.title-variant-drawer__submit');

    function closeDrawer() {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    submitBtn.addEventListener('click', function () {
      submitTitleVariantDrawer();
    });

    titleVariantDrawerEls = {
      overlay: overlay,
      drawer: drawer,
      titleEl: drawer.querySelector('.title-variant-drawer__product-title'),
      priceEl: drawer.querySelector('.title-variant-drawer__product-price'),
      optionsEl: drawer.querySelector('.title-variant-drawer__options'),
      errorEl: drawer.querySelector('.title-variant-drawer__error'),
      submitBtn: submitBtn,
      close: closeDrawer,
    };

    return titleVariantDrawerEls;
  }

  function formatTitleMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function openTitleVariantDrawer(button) {
    var els = ensureTitleVariantDrawer();

    els.titleEl.textContent = button.getAttribute('data-product-title') || '';
    els.priceEl.textContent = '';
    els.optionsEl.innerHTML = '<p class="title-variant-drawer__loading">Loading...</p>';
    els.errorEl.style.display = 'none';
    els.submitBtn.disabled = true;
    els.submitBtn.classList.remove('is-loading');
    els.submitBtn.removeAttribute('data-variant-id');

    els.drawer.classList.add('active');
    els.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    var productUrl = button.getAttribute('data-product-url');
    if (!productUrl) return;

    fetch(productUrl + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        titleVariantDrawerProduct = product;
        renderTitleVariantDrawerOptions(product);
      })
      .catch(function (error) {
        console.error('Failed to load product:', error);
        els.optionsEl.innerHTML = '';
        els.errorEl.textContent = 'Unable to load options. Please try again.';
        els.errorEl.style.display = 'block';
      });
  }

  function getTitleOptionName(option) {
    if (option && typeof option === 'object') return option.name || '';
    return option;
  }

  function renderTitleVariantDrawerOptions(product) {
    var els = ensureTitleVariantDrawer();
    els.priceEl.textContent = formatTitleMoney(product.price);

    var valueMap = [];
    var oi;
    for (oi = 0; oi < product.options.length; oi++) valueMap.push([]);
    for (var vi = 0; vi < product.variants.length; vi++) {
      var v = product.variants[vi];
      var vals = [v.option1, v.option2, v.option3];
      for (oi = 0; oi < product.options.length; oi++) {
        var val = vals[oi];
        if (val != null && valueMap[oi].indexOf(val) === -1) valueMap[oi].push(val);
      }
    }

    titleVariantDrawerSelections = [];
    for (oi = 0; oi < product.options.length; oi++) titleVariantDrawerSelections.push(null);

    var html = '';
    for (oi = 0; oi < product.options.length; oi++) {
      html +=
        '<div class="title-variant-drawer__field">' +
        '<select class="title-variant-drawer__select" data-option-index="' + oi + '">' +
        '<option value="" disabled selected>' + getTitleOptionName(product.options[oi]) + '</option>';
      for (var vv = 0; vv < valueMap[oi].length; vv++) {
        html += '<option value="' + valueMap[oi][vv].replace(/"/g, '&quot;') + '">' + valueMap[oi][vv] + '</option>';
      }
      html +=
        '</select>' +
        '<svg class="title-variant-drawer__chevron" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="1.5" fill="none"/>' +
        '</svg>' +
        '</div>';
    }
    els.optionsEl.innerHTML = html;

    var selects = els.optionsEl.querySelectorAll('.title-variant-drawer__select');
    for (var si = 0; si < selects.length; si++) {
      selects[si].addEventListener('change', function () {
        var idx = parseInt(this.getAttribute('data-option-index'), 10);
        titleVariantDrawerSelections[idx] = this.value || null;
        updateTitleVariantDrawerSelection();
      });
    }

    updateTitleVariantDrawerSelection();
  }

  function updateTitleVariantDrawerSelection() {
    var els = ensureTitleVariantDrawer();
    var product = titleVariantDrawerProduct;
    if (!product) return;

    els.errorEl.style.display = 'none';

    var complete = true;
    for (var i = 0; i < titleVariantDrawerSelections.length; i++) {
      if (!titleVariantDrawerSelections[i]) {
        complete = false;
        break;
      }
    }

    if (!complete) {
      els.submitBtn.disabled = true;
      els.submitBtn.removeAttribute('data-variant-id');
      return;
    }

    var matched = null;
    for (var vi = 0; vi < product.variants.length; vi++) {
      var v = product.variants[vi];
      var vals = [v.option1, v.option2, v.option3];
      var isMatch = true;
      for (var oi = 0; oi < titleVariantDrawerSelections.length; oi++) {
        if (vals[oi] !== titleVariantDrawerSelections[oi]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) {
        matched = v;
        break;
      }
    }

    if (!matched) {
      els.submitBtn.disabled = true;
      els.submitBtn.removeAttribute('data-variant-id');
      els.errorEl.textContent = 'This combination is not available.';
      els.errorEl.style.display = 'block';
      return;
    }

    els.priceEl.textContent = formatTitleMoney(matched.price);

    if (!matched.available) {
      els.submitBtn.disabled = true;
      els.submitBtn.removeAttribute('data-variant-id');
      els.errorEl.textContent = 'This combination is sold out.';
      els.errorEl.style.display = 'block';
      return;
    }

    els.submitBtn.disabled = false;
    els.submitBtn.setAttribute('data-variant-id', matched.id);
  }

  function submitTitleVariantDrawer() {
    var els = ensureTitleVariantDrawer();
    var variantId = els.submitBtn.getAttribute('data-variant-id');
    if (!variantId || els.submitBtn.disabled || els.submitBtn.classList.contains('is-loading')) return;

    els.submitBtn.classList.add('is-loading');
    els.submitBtn.disabled = true;

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    var cartItemsComponents = document.querySelectorAll('cart-items-component');
    var sectionIds = [];
    for (var c = 0; c < cartItemsComponents.length; c++) {
      var sectionId = cartItemsComponents[c].getAttribute('data-section-id');
      if (sectionId) sectionIds.push(sectionId);
    }
    if (sectionIds.length > 0) {
      formData.append('sections', sectionIds.join(','));
    }

    var addUrl = window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        els.submitBtn.classList.remove('is-loading');

        if (response.status) {
          els.submitBtn.disabled = false;
          els.errorEl.textContent = response.message || 'Unable to add to cart.';
          els.errorEl.style.display = 'block';
          return;
        }

        els.close();

        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: response,
          sourceId: variantId,
          data: {
            source: 'product-form-component',
            itemCount: 1,
            variantId: variantId,
            sections: response.sections,
          },
        };
        document.dispatchEvent(evt);
      })
      .catch(function (error) {
        console.error('Add to cart error:', error);
        els.submitBtn.classList.remove('is-loading');
        els.submitBtn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.product-title-add-to-cart');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    if (button.disabled || button.classList.contains('is-loading')) return;

    var optionCount = parseInt(button.getAttribute('data-option-count'), 10) || 1;
    if (optionCount > 1) {
      openTitleVariantDrawer(button);
      return;
    }

    var variantId = button.getAttribute('data-default-variant-id');
    var available = button.getAttribute('data-default-available') !== 'false';

    if (!variantId || !available) return;

    button.classList.add('is-loading');
    button.disabled = true;

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    var cartItemsComponents = document.querySelectorAll('cart-items-component');
    var sectionIds = [];
    cartItemsComponents.forEach(function (item) {
      var sectionId = item.getAttribute('data-section-id');
      if (sectionId) sectionIds.push(sectionId);
    });
    if (sectionIds.length > 0) {
      formData.append('sections', sectionIds.join(','));
    }

    var addUrl = window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        button.classList.remove('is-loading');
        button.disabled = false;

        if (response.status) {
          button.classList.add('is-error');
          setTimeout(function () {
            button.classList.remove('is-error');
          }, 2000);
          return;
        }

        button.classList.add('is-added');
        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1500);

        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: response,
          sourceId: variantId,
          data: {
            source: 'product-form-component',
            itemCount: 1,
            variantId: variantId,
            sections: response.sections,
          },
        };
        document.dispatchEvent(evt);
      })
      .catch(function (error) {
        console.error('Add to cart error:', error);
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
